import React, { ReactElement } from 'react';
import { Tbody, BoxProps } from '@wegroup/design-system';
import { Row } from '@tanstack/react-table';
import ReactTableV8BodyRow from './ReactTableV8BodyRow';

interface Props<TData> {
  rows: Row<TData>[];
  isScrollable?: boolean;
  onRowClick?: (index: number) => void;
  spannedCellRenderer: (value: unknown) => ReactElement;
  getRowSx?: (row: Row<TData>) => BoxProps['sx'];
}

const ReactTableV8Body = <TData,>({
  rows,
  isScrollable = false,
  spannedCellRenderer,
  onRowClick,
  getRowSx,
}: Props<TData>) => {
  return (
    <Tbody>
      {rows.map((row) => (
        <ReactTableV8BodyRow
          key={row.id}
          row={row}
          isScrollable={isScrollable}
          spannedCellRenderer={spannedCellRenderer}
          {...(onRowClick && { onClick: () => onRowClick(row.index) })}
          getRowSx={getRowSx}
        />
      ))}
    </Tbody>
  );
};

export default ReactTableV8Body;

